const VeteranStatusSection = {
  name: 'veteranStatus',
  title: 'VETERAN STATUS',
  container: 'default',
  titleVariant: 'subsection',
  fields: [
    {
      variant: 'radioGroup',
      name: 'veteran',
      label: 'Are you a veteran?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
        { label: 'Do not wish to provide', value: 'doNotWishToProvide' },
      ],
      rules: {
        required: true,
      },
      sx: {
        flexDirection: 'row',
      },
    },
  ],
};

export default VeteranStatusSection;
